import { ApiParameter, get} from "@insite/client-framework/Services/ApiService"
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface EddModal extends ApiParameter{
  customer:string;
  zipcode : string;
  ordertype: string;
  isSpecialOrder: boolean;
  items : string;
}

export interface EddResponseModal extends BaseModel{
  message:string;
  itemsEdd : ItemsEdd[];
}

export interface ItemsEdd {
  item: string;
  is_Range: boolean;
  edd_LB: string;
  edd_UB: string;
}
  
  const getEddUrl = "/api/v1/edd"


  export async function getEstimatedDeliveryDate(parameter: EddModal) {
    const response = await get<EddResponseModal>(getEddUrl, parameter as any);
    return response;
}
